module.exports = __webpack_public_path__ + "static/media/wizard_thumbnail.a2356615.png";